<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      language: 'zh-CN'
    }
  },
  created () {
    // 获取多语言信息
    this.getLocale()
  },
  methods: {
    getLocale () {
      let language = ''
      if (this.language) {
        language = this.language
      }
      if (language) {
        if (this.$i18n.messages[language]) {
          this.$baseUtil.setLanguage(language)
        }
      }
    }
  }
}
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  border: 0;
  font-family: 'PingFangSC';
}
html,body{

  width: 100%;
  height: 100%;
}
body::-webkit-scrollbar, html::-webkit-scrollbar {
  display: none;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
.sec_detail {
  img {
    max-width: 100% !important;
  }
}
</style>
